import React from 'react';
import { HeroSection } from './components/HeroSection';
import { EmpathySection } from './components/EmpathySection';
import { ProblemSection } from './components/ProblemSection';
import { MechanismSection } from './components/MechanismSection';
import { ProtocolSection } from './components/ProtocolSection';
import { DifferenceSection } from './components/DifferenceSection';
import { WhatsInsideSection } from './components/WhatsInsideSection';
import { AudienceSection } from './components/AudienceSection';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
export function App() {
  return <main className="w-full min-h-screen bg-cream-50 text-stone-800 antialiased overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />
      <EmpathySection data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <MechanismSection data-id="element-4" />
      <ProtocolSection data-id="element-5" />
      <DifferenceSection data-id="element-6" />
      <WhatsInsideSection data-id="element-7" />
      <AudienceSection data-id="element-8" />
      <OfferSection data-id="element-9" />
      <Footer data-id="element-10" />
    </main>;
}